module.exports = __webpack_public_path__ + "static/media/golfer-6-b.41e0b1d5.png";